<style lang="scss">
.dashbaord {
  .recent-post {
    .card-body {
      padding: 0;
    }

    h4 {
      padding-left: 1.5em;
      padding-top: 1.5em;
    }
  }

  .post-search-page {
    margin-bottom: 5px !important;
  }
}
</style>

<template>
  <div class="dashbaord">
<!--    <div class="row">-->
<!--      <div class="col-lg-4 col-xs-12">-->
<!--        <b-card title="Quick Links">-->
<!--          <b-card-text>-->
<!--            <b-btn class="full-width btn-success mb-1" :to="{name: 'post-search'}">Search for Post</b-btn>-->
<!--            <b-btn class="full-width btn-success mb-1" :to="{name: 'digital-replies'}">Search for Replies</b-btn>-->
<!--            <b-btn class="full-width btn-success" :to="{name: 'contacts'}">View Contacts</b-btn>-->
<!--          </b-card-text>-->
<!--        </b-card>-->
<!--      </div>-->
<!--    </div>-->

    <section class="row">
      <div class="col-lg-6 col-xs-12 col-sm-12">
        <b-card title="Recent Post" class="mb-1 recent-post px-0">
          <post-search :show-filters="false"></post-search>
        </b-card>
      </div>

      <div class="col-lg-6 col-xs-12 col-sm-12">
        <b-card title="Recent Replies" class="mb-1 recent-post px-0">
          <digital-replies-search :show-filters="false"></digital-replies-search>
        </b-card>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PostSearch from '@/views/PostSearch/PostSearch.vue';
import DigitalRepliesSearch from '@/views/DigitalReplies/DigitalRepliesSearch.vue';

export default {
  components: {
    PostSearch,
    DigitalRepliesSearch,
  },
  computed: {
    ...mapState({}),
  },
  mounted() {
    this.$store.commit('post/SET_FILTER_ITEM', { name: 'sort', value: '-updated_at' });
    this.$store.commit('replies/SET_FILTER_ITEM', { name: 'sort', value: '-updated_at' });
  },
}
</script>

<style>

</style>
